import { optionTitle_actionConfirmations } from './ActionConfirmationsOption.locstring.json';
import { LazyModule } from 'owa-bundling';
import { createLazyOption, LazyOption } from 'owa-options-core';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ActionConfirmationsOption: LazyOption = createLazyOption(
    {
        key: 'actionNotifications',
        titleStringKey: optionTitle_actionConfirmations,
        searchTermsStringKey: optionTitle_actionConfirmations,
    },
    lazyFullModule,
    m => m.default
);
export default ActionConfirmationsOption;
